import { extractErr } from '@/components/ui/inline-edit'

/**
 * When an axios request is made with ``responseType: 'blob'``, BOTH success
 * and error responses arrive as Blob. JSON error bodies (``{detail: "..."}``)
 * aren't auto-parsed, so a normal ``extractErr`` falls back to the generic
 * "Request failed with status code N" message.
 *
 * This helper reads the Blob, attempts JSON parse, and pulls the ``detail``
 * field. Falls back to the raw blob text, then to ``extractErr``.
 */
export async function blobErr(err: any): Promise<string> {
  try {
    const data = err?.response?.data
    if (data instanceof Blob) {
      const text = await data.text()
      try {
        const parsed = JSON.parse(text)
        if (parsed?.detail) return String(parsed.detail)
        if (typeof parsed === 'string') return parsed
        return text
      } catch {
        return text
      }
    }
  } catch {
    /* fall through */
  }
  return extractErr(err)
}
